import { useAtom } from 'jotai';
import styled from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { IconButton } from '@creditornot/cb-button';
import { Tooltip } from '@creditornot/cb-popover';
import { authenticator } from 'common/auth/authenticator';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useUser } from 'common/hooks/useUser';
import { themeModeAtom } from 'common/state/themeState';

const UserInfoSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-left: 8px;
  padding-right: 8px;
`;

const UserEmailContainer = styled.div`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 8px;
`;

const UserEmail = styled.span`
  width: 100%;
  white-space: nowrap;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

type Props = {
  onNavigate?: () => void;
};

export const NavigationUserInfo = ({ onNavigate }: Props) => {
  const formatMessage = useFormatMessage();
  const { user } = useUser();
  const [themeMode, setThemeMode] = useAtom(themeModeAtom);

  const themeButtonLabel =
    themeMode === 'light'
      ? formatMessage('components.navigation_menu.turn_dark_mode_on')
      : formatMessage('components.navigation_menu.turn_light_mode_on');

  return (
    <UserInfoSection>
      <UserEmailContainer>
        <UserEmail>{user?.email}</UserEmail>
      </UserEmailContainer>
      <ButtonsContainer>
        <Tooltip placement="top" content={themeButtonLabel}>
          <IconButton
            size="tiny"
            variant="neutral"
            background="solid"
            aria-label={themeButtonLabel}
            onClick={() => setThemeMode(themeMode === 'light' ? 'dark' : 'light')}
          >
            <Icon source={themeMode === 'light' ? icons.moon : icons.sun} size="small" />
          </IconButton>
        </Tooltip>
        <Tooltip placement="top" content={formatMessage('components.navigation_menu.sign_out')}>
          <IconButton
            icon={icons.signOut}
            style={{ marginLeft: 8 }}
            variant="neutral"
            background="solid"
            size="tiny"
            data-test-id="logout-button"
            aria-label={formatMessage('components.navigation_menu.sign_out')}
            onClick={() => {
              onNavigate?.();
              authenticator.performLogout?.();
            }}
          />
        </Tooltip>
      </ButtonsContainer>
    </UserInfoSection>
  );
};
